import { useEffect, useState } from "react";
import "../../../App.css";
import toGroupLayers from "../weatherLayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWind } from "@fortawesome/free-solid-svg-icons";
import { LocationMarkerPopup } from "../../MainWindow";
import { getGlobalLayer } from "../../MainWindow";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { allWeatherMapECMWF, allWeatherMapICON } from "../weatherLayer";
import { weatherMapECMF } from "../weatherLayer";
import { weatherMapICON } from "../weatherLayer";
import { ecmf, ICON } from "../weatherLayer";
import { useTheme } from "../../../theme/ThemeContext";
import { useMenu } from "../../../roundMenuContext/roundMenuContext";
import {
  ecmf3hEnd,
  ecmf3hInterval,
  ecmf3hStart,
  ecmf6hEnd,
  ecmf6hInterval,
  ecmf6hStart,
  icon1hInterval,
  icon1hStart,
  icon1hEnd,
  icon3hInterval,
  icon3hStart,
  icon3hEnd,
  layerStartDate,
  layerIconStartDate,
} from "../../../TimeLine/BackgroundMapTimeLine/TimeLineService";
import { useMapLayersContext } from "../../../provider/MapLayers";

interface TimelineElement {
  id: string;
  stimestamp: number;
  Interval: number;
  edtimestamp: number;
}

interface WindLayerProps {
  setTimeLayer: (layer: string) => void;
  weatherlayerState: string;
  senddValueFromWind: (value: string) => void;
  timeLineHour: string;
  timeLineDate: string;
  getVoiceRecognitionValue: string;
  timelineData: TimelineElement[];
  selectModel: string;
}

let isButtonClicked: boolean = false;
let windMap: Map<string, ImageLayer<ImageWMS>> = new Map();
let windMapIcon: Map<string, ImageLayer<ImageWMS>> = new Map();
export let windWmsLayers: Array<string> = [];
export let windWmsLayersCurrent: string = "";
let isDateLoad: boolean = true;
let isDateLoadModel: boolean = true;

const WindLayer: React.FC<WindLayerProps> = ({
  setTimeLayer,
  weatherlayerState,
  senddValueFromWind,
  timeLineHour,
  timeLineDate,
  getVoiceRecognitionValue,
  timelineData,
  selectModel,
}) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [hoveredWind, setHoveredWind] = useState(false);
  const [isIconReady, setIconReady] = useState(false);
  const [isecmwfReady, setecmwfIsReady] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();
  const { selectLayerInMap, loadLayerInMap, setIsInitialLoad, isInitialLoad,isWindLoad,setIsWindLoad } = useMapLayersContext();

  const resultIconMap = new Map<number, string>();

  useEffect(() => {
    if (weatherlayerState === "windnot") {
      isButtonClicked = true;
      if (!isDateLoadModel) {
        // windIconClick();
        // isDateLoad=false;
      }
      if (selectModel === "ICON") {
        try {
          const layer = windMapIcon.get(timeLineDate + "-" + timeLineHour);
          if (layer) {
            getGlobalLayer(layer);
            toGroupLayers(layer, false, "wind");
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      } else {
        try {
          const layer = windMap.get(timeLineDate + "-" + timeLineHour);
          if (layer) {
            getGlobalLayer(layer);
            toGroupLayers(layer, false, "wind");
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      }
    }
  }, [timeLineHour, timeLineDate]);

  useEffect(() => {
    if (menu === "Wind") {
      isButtonClicked = false;
      setIsClicked((prevState) => !prevState);
      if (isClicked === true) {
        setTimeLayer("wind");
        LocationMarkerPopup("wind");
      } else if (isClicked === false) {
        setTimeLayer("windnot");
        LocationMarkerPopup("windnot");
        senddValueFromWind("wind");
      }
      windIconClick();
    }
  }, [menu]);

  useEffect(() => {
    if(!isWindLoad){
  
      if(loadLayerInMap==="wind"){
        if (isClicked == true) {  
          setTimeLayer("wind");
          LocationMarkerPopup("wind");
          windIconClick();
          selectLayerInMap("windnot");
          setIsClicked(false);
        } else if (isClicked === false) {
          setTimeLayer("windnot");
          LocationMarkerPopup("windnot");
          senddValueFromWind("wind");
          selectLayerInMap("wind");
          setIsClicked(true);
        }
      }else if(loadLayerInMap==="windnot"){
        setTimeLayer("wind");
        LocationMarkerPopup("wind");
        windIconClick();
        selectLayerInMap("windnot");
        setIsClicked(false);
      }
      setIsWindLoad(true);
    }

}, [loadLayerInMap]);

  useEffect(() => {

    if (weatherlayerState === "windnot") {
      if (loadLayerInMap !== "tides") {
        setIsClicked(true);
        LocationMarkerPopup("windnot");
      }

    } else if (weatherlayerState === "flood") {
      setIsClicked(false);
      LocationMarkerPopup("wind");
    } else if (weatherlayerState === "satellite not") {
      setIsClicked(false);
      LocationMarkerPopup("wind");
    } else {
      setIsClicked(false);
     // LocationMarkerPopup("wind");
      // windIconClick();
    }
  }, [weatherlayerState, isClicked]);

  useEffect(() => {
    if (getVoiceRecognitionValue === "open wind layer") {
      isButtonClicked = false;
      setIsClicked((prevState) => !prevState);
      if (isClicked === true) {
        setTimeLayer("wind");
        LocationMarkerPopup("wind");
      } else if (isClicked === false) {
        setTimeLayer("windnot");
        LocationMarkerPopup("windnot");
        senddValueFromWind("wind");
      }
      windIconClick();
    } else if (getVoiceRecognitionValue === "close wind layer") {
      isButtonClicked = false;
      setIsClicked((prevState) => !prevState);
      if (isClicked === true) {
        setTimeLayer("wind");
        LocationMarkerPopup("wind");
      } else if (isClicked === false) {
        setTimeLayer("windnot");
        LocationMarkerPopup("windnot");
        senddValueFromWind("wind");
      }
      windIconClick();
    }
  }, [getVoiceRecognitionValue]);

  useEffect(() => { }, [isButtonClicked]);

  useEffect(() => { }, [isClicked]);

  function formatTimestamp(timestamp: number): string {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}-${hour}:${minute}`;
  }

  function parseDateString(dateString: string): string | null {
    const offsetMinutes = new Date().getTimezoneOffset();
    const dateRegex = /^(\d{4})-(\d{2})-(\d{2})-(\d{2}):(\d{2})$/;
    const match = dateString.match(dateRegex);
    if (!match) {
      console.error("Invalid date format:", dateString);
      return null;
    }
    const [, year, month, day, hour, minute] = match;
    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute)
    );
    date.setMinutes(date.getMinutes() + offsetMinutes);
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    return formattedDate;
  }

  useEffect(() => {
    if (icon3hStart && icon3hStart !== 0) {
      setIconReady(true);
    }
  }, [icon3hStart]);

  useEffect(() => {
    if (!isIconReady) return;
    if (selectModel === "ICON" && weatherlayerState === "windnot") {
      let i = 0;
      for (; i <= 78; i++) {
        const value = icon1hStart + i * icon1hInterval;
        if (value > icon1hEnd) break;
        resultIconMap.set(i, formatTimestamp(value));
      }

      for (let j = i; j <= 112; j++) {
        const value = icon3hStart + (j - 78) * icon3hInterval;
        if (value > icon3hEnd) break;
        resultIconMap.set(j, formatTimestamp(value));
      }
      try {
        for (let i = 0; i <= ICON.size; i++) {
          let dateBefore = resultIconMap.get(i) ?? "";
          let dayPass = parseDateString(dateBefore);
          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerIconStartDate}_icon_${dayPass}:00_dsuvspeed_1000hpa`,
                STYLES: "weather:wind",
              },
              imageLoadFunction: (image, src) => {
                const [baseUrl, queryString] = src.split("?");
                const queryParams = new URLSearchParams(queryString);

                const urlObj = new URL(src);
                const layers = urlObj.searchParams.get("LAYERS");
                const bbox = urlObj.searchParams.get("BBOX");

                for (let cnti = i; cnti < Math.min(i + 10, ICON.size); cnti++) {
                  let dateBeforeCache = resultIconMap.get(cnti) ?? "";
                  let dayPassCache = parseDateString(dateBeforeCache);

                  queryParams.set(
                    "LAYERS",
                    `weather:${layerIconStartDate}_icon_${dayPassCache}:00_dsuvspeed_1000hpa`
                  );
                  const urlCached = `${baseUrl}?${queryParams.toString()}`;

                  preloadImage(
                    urlCached,
                    bbox!,
                    `weather:${layerIconStartDate}_icon_${dayPassCache}:00_dsuvspeed_1000hpa`
                  );
                }

                const modifiedSrc = `${src}`;
                const imgElement = image.getImage();
                if (imgElement instanceof HTMLImageElement) {
                  imgElement.src = modifiedSrc;
                } else {
                  console.error(
                    "imageLoadFunction: Expected an HTMLImageElement but got:",
                    imgElement
                  );
                }
              },
              serverType: "geoserver",

              projection: "EPSG:4326",
            }),
          });
          layers.set("name", `wind_${i}`);
          const key = resultIconMap.get(i);
          if (key !== undefined) {
            windMapIcon.set(key, layers);
          }
          allWeatherMapICON("windIcon", windMapIcon);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
      try {
        if (windMapIcon) {
          const layer = windMapIcon.get(timeLineDate + "-" + timeLineHour);
          if (layer) {
            getGlobalLayer(layer);
       
              toGroupLayers(layer, false, "wind");
            
          }
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    }
  }, [selectModel, isIconReady, weatherlayerState]);

  useEffect(() => {
    // Check if ecmf6hStart has a valid value
    if (ecmf6hStart && ecmf6hStart !== 0) {
      setecmwfIsReady(true); // Set ready state to true when ecmf6hStart is valid
    }
  }, [ecmf6hStart]);

  const resultMap = new Map<number, string>();

  // cached details map for wind 2024-12-16
  const cachedMap: Map<string, Map<string, boolean>> = new Map();

  async function preloadImage(
    url: string,
    bbox: string,
    layer: string
  ): Promise<void> {
    try {
      const cache = await caches.open("image-cache");
      const cachedResponse = await cache.match(url);

      let cachedByLayer: Map<string, boolean> = new Map();

      if (cachedMap.get(bbox) != null) {
        cachedByLayer = cachedMap.get(bbox)!;
      } else {
        cachedMap.set(bbox, cachedByLayer);
      }

      if (
        cachedByLayer.get(layer) !== null &&
        cachedByLayer.get(layer) === true
      ) {
        console.log("Image found in cache and map");
      } else {
        const response = await fetch(url);
        if (response.ok) {
          const blob = await response.blob();
          await cache.put(url, new Response(blob));
          const imgElement = document.createElement("img");
          imgElement.src = url;
          cachedByLayer.set(layer, true);
          cachedMap.set(bbox, cachedByLayer);
        } else {
          cachedByLayer.set(layer, false);
          cachedMap.set(bbox, cachedByLayer);
          console.error("Failed to fetch image:", response.statusText);
        }
      }
    } catch (error) {
      console.error("Error during image caching and preload:", error);
    }
  }

  useEffect(() => {
    if (!isecmwfReady) return;
    if (selectModel === "ECMWF" && weatherlayerState === "windnot") {
      let i = 0;
      for (; i <= 48; i++) {
        const value = ecmf3hStart + i * ecmf3hInterval;
        if (value > ecmf3hEnd) break;
        resultMap.set(i, formatTimestamp(value));
      }

      for (let j = i; j <= 64; j++) {
        const value = ecmf6hStart + (j - 48) * ecmf6hInterval;
        if (value > ecmf6hEnd) break;
        resultMap.set(j, formatTimestamp(value));
      }

      try {
        for (let i = 0; i <= ecmf.size; i++) {
          let dateBefore = resultMap.get(i) ?? "";

          let dayPass = parseDateString(dateBefore);
          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerStartDate}_ecmwf_${dayPass}:00_dsuvspeed_1000hpa`,
                STYLES: "weather:wind",
              },
              imageLoadFunction: (image, src) => {
                const [baseUrl, queryString] = src.split("?");
                const queryParams = new URLSearchParams(queryString);

                const urlObj = new URL(src);
                const layers = urlObj.searchParams.get("LAYERS");
                const bbox = urlObj.searchParams.get("BBOX");

                for (let cnti = i; cnti < Math.min(i + 10, ecmf.size); cnti++) {
                  let dateBeforeCache = resultMap.get(cnti) ?? "";
                  let dayPassCache = parseDateString(dateBeforeCache);
                  queryParams.set(
                    "LAYERS",
                    `weather:${layerStartDate}_ecmwf_${dayPassCache}:00_dsuvspeed_1000hpa`
                  );
                  const urlCached = `${baseUrl}?${queryParams.toString()}`;
                  preloadImage(
                    urlCached,
                    bbox!,
                    `weather:${layerStartDate}_ecmwf_${dayPassCache}:00_dsuvspeed_1000hpa`
                  );
                }

                const modifiedSrc = `${src}`;
                const imgElement = image.getImage();
                if (imgElement instanceof HTMLImageElement) {
                  imgElement.src = modifiedSrc;
                } else {
                  console.error(
                    "imageLoadFunction: Expected an HTMLImageElement but got:",
                    imgElement
                  );
                }
              },
              serverType: "geoserver",
              projection: "EPSG:4326",
            }),
          });
          layers.set("name", `wind_${i}`);
          const key = resultMap.get(i);
          if (key !== undefined) {
            windMap.set(key, layers);
          }
          allWeatherMapECMWF("windEcmwf", windMap);
        }

        // if (isDateLoadModel) {
        //   windIconClick();
        //   isDateLoadModel = false;
        // }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
      try {
        if (windMap) {
          const layer = windMap.get(timeLineDate + "-" + timeLineHour);
          if (layer) {
            getGlobalLayer(layer);
              toGroupLayers(layer, false, "wind");
          }
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    }
  }, [isecmwfReady, weatherlayerState, selectModel]);

  const windIconClick = () => {
    try {
      let windLayerMap;
      if (selectModel === "ECMWF") {
        windLayerMap = weatherMapECMF.get("windEcmwf");
      } else if (selectModel === "ICON") {
        windLayerMap = weatherMapICON.get("windIcon");
      }

      if (windLayerMap) {
 
        const layer = windLayerMap.get(timeLineDate + "-" + timeLineHour);
        if (layer) {
          toGroupLayers(layer, true, "wind");
        }
      }
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };

  useEffect(() => {
    if (loadLayerInMap === "wind" || loadLayerInMap === "") {
      if (!isInitialLoad) {
        isButtonClicked = false;
        setIsClicked((prevState) => !prevState);
        setIsInitialLoad(true);
        if (isClicked === true) {
          setTimeLayer("wind");
          LocationMarkerPopup("wind");
        } else if (isClicked === false) {
          setTimeLayer("windnot");
          senddValueFromWind("wind");
          LocationMarkerPopup("windnot");
        }
      }
    }
  }, []);

  return (
    <>
      <div
        className="leftsidemenulist-btn-cover"
        onClick={() => {
          isButtonClicked = false;
          setIsClicked((prevState) => !prevState);
          if (isClicked === true) {
            setTimeLayer("wind");
            LocationMarkerPopup("wind");
            windIconClick();
            selectLayerInMap("windnot");
          } else if (isClicked === false) {
            setTimeLayer("windnot");
            LocationMarkerPopup("windnot");
            senddValueFromWind("wind");
            selectLayerInMap("wind");
          }
        }}
        onTouchStart={() => {
          isButtonClicked = false;
          setIsClicked((prevState) => !prevState);
          if (isClicked === true) {
            setTimeLayer("wind");
            LocationMarkerPopup("wind");
            windIconClick();
            selectLayerInMap("windnot");
          } else if (isClicked === false) {
            setTimeLayer("windnot");
            LocationMarkerPopup("windnot");
            senddValueFromWind("wind");
            selectLayerInMap("wind");
          }
        }}
      >
        <div
          onMouseEnter={() => setHoveredWind(true)}
          onMouseLeave={() => setHoveredWind(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon size="1x" icon={faWind} className="leftside-icon" />
        </div>
        {theme === "light" && (
          <div
            className={
              isClicked
                ? "leftsidemenulist-btn-tooltip-clicked-light"
                : hoveredWind
                  ? "leftsidemenulist-btn-tooltip-hover-light"
                  : "leftsidemenulist-btn-tooltip-light"
            }
            onMouseEnter={() => setHoveredWind(true)}
            onMouseLeave={() => setHoveredWind(false)}
          >
            Wind
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isClicked
                ? "leftsidemenulist-btn-tooltip-clicked"
                : hoveredWind
                  ? "leftsidemenulist-btn-tooltip-hover"
                  : "leftsidemenulist-btn-tooltip"
            }
            onMouseEnter={() => setHoveredWind(true)}
            onMouseLeave={() => setHoveredWind(false)}
          >
            Wind
          </div>
        )}
      </div>
    </>
  );
};

export default WindLayer;
